import Axios from 'axios';
import {getToken} from "./admin";
import {Message} from 'element-ui'
import { handleSessionExpired } from '@/utils/sessionExpire'

const request = Axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
});

const decodeValue = (obj) => {
    Object.entries(obj).forEach(([key, value]) => {
        if (value){
            if (typeof value === 'object') {
                decodeValue(value)
            }
            if (typeof value ==='string') {
                try {
                    obj[key] = decodeURIComponent(value)
                } catch (e) {
                    if (e instanceof URIError) {
                        let decodedValue = value.replace(/%([0-9A-Fa-f]{2})/g, function(match, p1) {
                            return String.fromCharCode(parseInt(p1, 16));
                        });
                        obj[key] = decodedValue
                    } else {
                        console.error('其他错误:', e);
                    }
                }
            }
        }
    })
}

request.interceptors.request.use(
    config => {
        if (config.data){
            const data = config.data;
            decodeValue(data);
        }

        if (getToken()) {
            config.headers['Authorization'] = 'bearer ' + getToken();
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

request.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        const response = error.response
        if (!response) {
            Message({
                message: '网络异常，请稍后重试',
                type: 'error',
                duration: 3 * 1000
            });
            return Promise.reject(error)
        }

        const status = response.status
        const config = error.config

        if (status === 401) {
            const data = response.data || {}
            const message = data.error_description || data.msg || data.message
            handleSessionExpired(message, config)
            return Promise.reject(error)
        }
        if (status === 400) {
            const data = response.data || {}
            Message({
                message: data.error_description === '无法获取用户信息' ? "用户名或密码错误" : data.msg,
                type: 'error',
                duration: 3 * 1000
            });
        }
        if (status === 500 || status === 404 || status === 502) {
            Message({
                message: "服务器出现错误",
                type: 'error',
                duration: 3 * 1000
            });
        }
        return Promise.reject(error)
    }
);

export default request;
